import { getGlobalClassNames, FontSizes } from '../../Styling';
export var DocumentCardLocationGlobalClassNames = {
    root: 'ms-DocumentCardLocation'
};
export var getStyles = function (props) {
    var theme = props.theme, className = props.className;
    var palette = theme.palette;
    var classNames = getGlobalClassNames(DocumentCardLocationGlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            {
                fontSize: FontSizes.small,
                color: palette.neutralPrimary,
                display: 'block',
                padding: '8px 16px',
                position: 'relative',
                textDecoration: 'none',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                selectors: {
                    ':hover': {
                        color: palette.themePrimary,
                        cursor: 'pointer'
                    }
                }
            },
            className
        ]
    };
};
//# sourceMappingURL=DocumentCardLocation.styles.js.map